module.exports = __webpack_public_path__ + "static/media/work-03-small.a31695f5.jpg";